<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item> <router-link to="/accounting/cash-in">Cash In</router-link></b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>
      <b-col md="6">
        <!-- terserah mau apa -->
      </b-col>
    </b-row>
    <div class="border-bottom"></div>
    <div v-if="isLoading" style="z-index: 1000;">
       <div class="text-center justify-items-center justify-content-center spinner-position" style="margin: 10% auto;">
           <b-spinner small type="grow" label="Small Spinner"></b-spinner>
           <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
           <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
       </div>
      </div>
      <div v-else>
        <b-row class="mt-3">
          <b-col md="6">
            <b-row>
              <b-col md="2">
                <label class="labels">Number</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p class="font-weight-bold" v-text="model.cashNumber ? model.cashNumber : '-'"></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label class="labels">date</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p v-text="model.cashDate ? new Date(model.cashDate).toLocaleDateString() : '-'"></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label class="labels">Note</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p v-text="model.cashNote ? model.cashNote : '-'"></p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col md="12">
            <div class="table table-responsive">
              <h4>Cash In History</h4>
              <table class="w-75">
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Description</th>
                    <th>Debit</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in cashInData" :key="list.uuid">
                    <td v-text="list.journalAccount.journalAccountName"></td>
                    <td v-text="list.cashTransactionNote !== '' ? list.cashTransactionNote : '-'"></td>
                    <td v-text="list.cashTransactionDebit !== 0 ? formatNumber(list.cashTransactionDebit) : 0"></td>
                    <td v-text="list.cashTransactionCredit !==0 ? formatNumber(list.cashTransactionCredit) : 0"></td>
                  </tr>
                </tbody>    
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6"></b-col>
          <b-col md="5">
             <div class="w-50 d-flex row-cols-2">
               <div>
                <b-form-input readonly :value="model.cashTotalDebit !== null ? formatNumber(model.cashTotalDebit) : 0"></b-form-input>
                <p>Total Debit</p>
               </div>
               <div class="ml-3">
                <b-form-input readonly :value="model.cashTotalCredit !== null ? formatNumber(model.cashTotalCredit) : 0"></b-form-input>
                <p>Total Credit</p>
               </div>
              </div>
              
          </b-col>
        </b-row>
      </div>
       <b-button class="mt-5 mb-4" @click="goBack()" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
  </b-card>
</template>

<script>
export default {
  name: 'detail-journal',
  components: {},
  data() {
    return {
      isLoading: false,
      apiUrl:{
        cashIn: window.AppConfig.apiUrl + 'cash'
      },
      model: {
        cashNumber: "",
        cashNote: "",
        cashDate: "",
        createdAt: "",
        updatedAt: "",
        cashTransaction: [],
        cashTotalCredit: 0,
        cashTotalDebit: 0
      },
      cashInData: [],
    }
  },

  mounted(){
    this.getDetail()
  },

  methods: {
    /** ======== GET DETAIL JOURNAL ===== */
    getDetail(){
      this.isLoading = true
      this.$http.get(this.apiUrl.cashIn + '/' + this.$route.params.uuid).then((response) => {
        console.log('response is:', response);
        this.model.cashNumber = response.data.cashNumber
        this.model.cashNote = response.data.cashNote
        this.model.cashDate = response.data.cashDate
        this.model.cashTotalCredit = response.data.cashTotalCredit,
        this.model.cashTotalDebit = response.data.cashTotalDebit
        if(response.data.cashTransaction !== null){
          this.cashInData = response.data.cashTransaction;
        }
        this.isLoading = false; 
      }).catch(error => {
        this.$store.dispatch('notification/error', error);
      })
    },

      formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    goBack(){
      window.goBack(this);
    }
  },
}
</script>